import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '../../../../shared';

import classNames from 'classnames';
import classes from './PreferenceRow.module.scss';

interface PreferenceRowProps {
  label: string;
  isPushEnabled: boolean;
  onPushChange: (isEnabled: boolean) => void;
  onEmailChange: (isEnabled: boolean) => void;
  isPushLocked?: boolean;
  isEmailEnabled?: boolean;
}

export const PreferenceRow: FunctionComponent<PreferenceRowProps> = ({
  label,
  isPushEnabled,
  onPushChange,
  onEmailChange,
  isPushLocked,
  isEmailEnabled,
}) => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'pushNotifications' });

  const emailCell = useMemo(() => {
    if (isEmailEnabled === undefined) {
      return (
        <span
          className={classNames(
            classes['preference-row__cell'],
            classes['preference-row__cell--empty']
          )}
          aria-hidden={true}
        >
          {'—'}
        </span>
      );
    }

    return (
      <Switch
        className={classes['preference-row__cell']}
        ariaLabel={ctxT('email-switch-label', { name: label })}
        checked={isEmailEnabled}
        onChange={onEmailChange}
      />
    );
  }, [ctxT, isEmailEnabled, label, onEmailChange]);

  return (
    <div className={classes['preference-row']}>
      <span className={classes['preference-row__label']}>{label}</span>
      <Switch
        className={classes['preference-row__cell']}
        ariaLabel={ctxT('push-switch-label', { name: label })}
        checked={isPushEnabled}
        disabled={isPushLocked}
        onChange={onPushChange}
      />
      {emailCell}
    </div>
  );
};
